(function () {
  'use strict';

  if (window.TPStandaloneInfiniteScrollStarted) return;
  window.TPStandaloneInfiniteScrollStarted = true;

  var LOOP_SELECTOR = '#AjaxinateLoop';
  var PAGINATION_SELECTOR = '#AjaxinatePagination';
  var PREFETCH_DISTANCE = 700;
  var REQUEST_TIMEOUT = 15000;
  var state = {
    loading: false,
    observer: null,
    pagination: null,
    retryTimer: null,
    retryCount: 0,
    requestId: 0,
    scheduled: false
  };

  function setStatus(status, details) {
    var root = document.documentElement;
    root.setAttribute('data-tp-infinite-scroll', status);

    if (details && details.url) {
      root.setAttribute('data-tp-infinite-scroll-url', details.url);
    }
    if (details && typeof details.retryCount !== 'undefined') {
      root.setAttribute('data-tp-infinite-scroll-retries', String(details.retryCount));
    }
    if (details && details.error) {
      root.setAttribute('data-tp-infinite-scroll-error', details.error);
    } else if (status !== 'error' && status !== 'retrying') {
      root.removeAttribute('data-tp-infinite-scroll-error');
    }
  }

  function getElements() {
    return {
      loop: document.querySelector(LOOP_SELECTOR),
      pagination: document.querySelector(PAGINATION_SELECTOR)
    };
  }

  function getNextLink(pagination) {
    return pagination ? pagination.querySelector('a[href]') : null;
  }

  function isNearViewport(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    return rect.top <= window.innerHeight + PREFETCH_DISTANCE && rect.bottom >= -PREFETCH_DISTANCE;
  }

  function reconnectObserver() {
    var elements = getElements();
    var pagination = elements.pagination;

    if (pagination === state.pagination) return;

    if (state.observer && state.pagination) {
      state.observer.unobserve(state.pagination);
    }

    state.pagination = pagination;

    if (state.observer && pagination) {
      state.observer.observe(pagination);
    }
  }

  function scheduleCheck() {
    if (state.scheduled) return;
    state.scheduled = true;

    window.requestAnimationFrame(function () {
      state.scheduled = false;
      check();
    });
  }

  function restoreLink(link, originalHTML) {
    if (!link || !document.documentElement.contains(link)) return;
    link.innerHTML = originalHTML;
    link.removeAttribute('aria-busy');
  }

  function initialiseNewProducts(loop, url, startIndex, addedCount) {
    try {
      if (window.PaloAlto) {
        if (typeof window.PaloAlto.initQuickButton === 'function') {
          window.PaloAlto.initQuickButton(loop);
        }
        if (window.PaloAlto.Badge && typeof window.PaloAlto.Badge.setPosition === 'function') {
          window.PaloAlto.Badge.setPosition();
        }
      }
    } catch (error) {
      console.warn('[TP Infinite Scroll] Product callbacks failed', error);
    }

    document.dispatchEvent(new CustomEvent('tp:infinite-scroll:loaded', {
      bubbles: true,
      detail: {
        url: url,
        productCount: loop.children.length,
        startIndex: startIndex,
        addedCount: addedCount
      }
    }));
  }

  function appendPage(html, url) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var newLoop = parsed.querySelector(LOOP_SELECTOR);
    var newPagination = parsed.querySelector(PAGINATION_SELECTOR);
    var elements = getElements();

    if (!elements.loop || !elements.pagination || !newLoop) {
      throw new Error('Missing collection grid in next page');
    }

    var startIndex = elements.loop.children.length;
    var addedCount = newLoop.children.length;
    var fragment = document.createDocumentFragment();
    while (newLoop.firstChild) {
      fragment.appendChild(newLoop.firstChild);
    }
    elements.loop.appendChild(fragment);

    if (newPagination) {
      elements.pagination.innerHTML = newPagination.innerHTML;
    } else {
      elements.pagination.remove();
    }

    initialiseNewProducts(elements.loop, url, startIndex, addedCount);
  }

  function retry(url, link, originalHTML, error) {
    state.loading = false;
    state.retryCount += 1;
    restoreLink(link, originalHTML);

    var message = error && error.message ? error.message : 'Request failed';
    setStatus('retrying', {
      url: url,
      retryCount: state.retryCount,
      error: message
    });

    window.clearTimeout(state.retryTimer);
    var delay = Math.min(1000 * Math.pow(2, state.retryCount - 1), 8000);

    state.retryTimer = window.setTimeout(function () {
      reconnectObserver();
      var elements = getElements();
      var nextLink = getNextLink(elements.pagination);

      if (nextLink && isNearViewport(elements.pagination)) {
        load(nextLink.href, nextLink);
      } else {
        check();
      }
    }, delay);

    console.warn('[TP Infinite Scroll] Retrying ' + url + ' in ' + delay + 'ms', error);
  }

  function load(url, link) {
    if (state.loading || !url) return;

    state.loading = true;
    state.requestId += 1;
    var requestId = state.requestId;
    var originalHTML = link ? link.innerHTML : '';
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = window.setTimeout(function () {
      if (controller) controller.abort();
    }, REQUEST_TIMEOUT);

    if (link) {
      link.setAttribute('aria-busy', 'true');
    }

    setStatus('loading', {
      url: url,
      retryCount: state.retryCount
    });

    fetch(url, {
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('HTTP ' + response.status);
      }
      return response.text();
    }).then(function (html) {
      if (requestId !== state.requestId) return;

      window.clearTimeout(timeout);
      appendPage(html, url);
      state.loading = false;
      state.retryCount = 0;
      setStatus('ready', { url: url, retryCount: 0 });
      reconnectObserver();

      window.setTimeout(function () {
        check();
      }, 0);
    }).catch(function (error) {
      if (requestId !== state.requestId) return;
      window.clearTimeout(timeout);
      retry(url, link, originalHTML, error);
    });
  }

  function check() {
    if (state.loading) return;

    reconnectObserver();
    var elements = getElements();
    var link = getNextLink(elements.pagination);

    if (!elements.loop || !elements.pagination || !link) {
      if (elements.loop && !link) setStatus('complete');
      return;
    }

    if (isNearViewport(elements.pagination)) {
      load(link.href, link);
    } else {
      setStatus('ready', {
        url: link.href,
        retryCount: state.retryCount
      });
    }
  }

  function onPaginationClick(event) {
    var target = event.target;
    var link = target && target.closest ? target.closest(PAGINATION_SELECTOR + ' a[href]') : null;
    if (!link) return;

    event.preventDefault();
    load(link.href, link);
  }

  function initialise() {
    if (!document.querySelector(LOOP_SELECTOR)) return;

    if (typeof IntersectionObserver === 'function') {
      state.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) check();
        });
      }, {
        root: null,
        rootMargin: PREFETCH_DISTANCE + 'px 0px',
        threshold: 0
      });
    }

    reconnectObserver();

    window.addEventListener('scroll', scheduleCheck, { passive: true });
    window.addEventListener('resize', scheduleCheck);
    window.addEventListener('orientationchange', scheduleCheck);
    document.addEventListener('click', onPaginationClick);

    var main = document.querySelector('#MainContent') || document.body;
    var mutationObserver = new MutationObserver(scheduleCheck);
    mutationObserver.observe(main, { childList: true, subtree: true });

    window.setInterval(check, 1500);
    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
})();